import { ButtonColor } from "@/common/enum/button-color";
import { CheckboxColor } from "@/common/enum/checkbox-color";
import { NoticeDisplayStatus } from "@/common/enum/notice-display-status";
import { formatDateToYYYYMMDD } from "@/common/util/date-util";
import { isDateInRange } from "@/common/util/is-date-in-range";
import { StatusButton } from "@/components/button/StatusButton";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { Checkbox, Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";
import moment from "moment";

interface Props {
  data: NoticeDetailDto;
  handleNoticeNameClick: (id: number) => void;
  checkedNoticeIds: number[];
  handleCheckItem: (noticeId: number) => void;
}

export const AdminNoticeRow: React.FC<Props> = ({
  data,
  handleNoticeNameClick,
  checkedNoticeIds,
  handleCheckItem,
}) => {
  const getNoticeDisplayStatus = () => {
    if (!data.popupStartDate || !data.popupEndDate) {
      return NoticeDisplayStatus.HIDE;
    }

    return isDateInRange(
      new Date(data.popupStartDate),
      new Date(data.popupEndDate)
    )
      ? NoticeDisplayStatus.DISPLAY
      : NoticeDisplayStatus.HIDE;
  };

  const getDateRange = () => {
    if (!data.popupStartDate || !data.popupEndDate) {
      return "-";
    }

    return `${moment(data.popupStartDate).format("YYYY-MM-DD")} ~ ${moment(
      data.popupEndDate
    ).format("YYYY-MM-DD")}`;
  };

  const dateRange = getDateRange();
  const noticeDisplayStatus = getNoticeDisplayStatus();
  const isChecked = checkedNoticeIds.includes(data.id);

  return (
    <Table.Row
      key={data.id}
      className="bg-white dark:border-gray-700 dark:bg-gray-800"
    >
      <Table.Cell className="w-[52px] flex items-center justify-center">
        <Checkbox
          color={isChecked ? CheckboxColor.DARK : ""}
          checked={isChecked}
          onChange={() => handleCheckItem(data.id)}
        />
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <StatusButton
            color={
              noticeDisplayStatus === NoticeDisplayStatus.DISPLAY
                ? ButtonColor.GREEN
                : ButtonColor.CUSTOM_GRAY
            }
          >
            {noticeDisplayStatus}
          </StatusButton>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {dateRange}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell onClick={() => handleNoticeNameClick(data.id)}>
        <CustomCell>
          <Body14Underline className="text-semantic-text-body">
            {data.title}
          </Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {data.user.name}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatDateToYYYYMMDD(data.createdAt)}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
